import React from 'react';
import { RouterProvider as ReactRouterProvider } from 'react-router-dom';
import { router } from '../../router/AppRouter';

/**
 * Router provider component using React Router v6
 * Provides the configured router to the application
 */
export const RouterProvider: React.FC = () => {
  return <ReactRouterProvider router={router} />;
};
